export default "__VITE_ASSET__OTvcJlxr__"